export default __webpack_public_path__ + "static/media/38.c0eaa8ba.png";